import { render, staticRenderFns } from "./RiscoCardiovascular.vue?vue&type=template&id=503a4624"
import script from "./RiscoCardiovascular.vue?vue&type=script&lang=js"
export * from "./RiscoCardiovascular.vue?vue&type=script&lang=js"
import style0 from "./RiscoCardiovascular.vue?vue&type=style&index=0&id=503a4624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports